import { Store } from '@/Core/Models/Stores'
import { Component, MapAction, MapGetter, Vue, Watch } from 'types-vue'

@Component
export default class Main extends Vue {
  @MapAction(Store.UnprocessedMarketerFiles)
  protected obtainUnprocessedMarketerFiles: () => Promise<void>
  @MapAction(Store.UnprocessedMarketerFiles) private updateCurrentPage: (pageNumber) => void
  @MapAction(Store.UnprocessedMarketerFiles) private newPageSize: (pageSize: number) => number
  @MapAction(Store.UnprocessedMarketerFiles) private processUrlQueryParams: (
    queryParams: any
  ) => Promise<any>

  @MapGetter(Store.UnprocessedMarketerFiles) protected pageSize: number
  @MapGetter(Store.UnprocessedMarketerFiles) protected totalElements: number
  @MapGetter(Store.UnprocessedMarketerFiles) protected listLoading: boolean
  @MapGetter(Store.UnprocessedMarketerFiles) protected totalActiveFilter: number

  /**
   * METHODS
   */

  private goToPageOne() {
    if (this.$route.query.page !== '1') {
      this.$router.push({ name: this.$route.name, query: { ...this.$route.query, page: '1' } })
    }
  }

  protected async processCurrentPage() {
    const pageNumber = parseInt(this.$route.query.page as string) || 1
    this.updateCurrentPage(pageNumber)
    await this.obtainUnprocessedMarketerFiles()
  }

  /**
   * EVENTS
   */

  protected async onChangePageSize(pageSize: number) {
    this.newPageSize(pageSize)
    this.goToPageOne()
    this.processCurrentPage()
  }

  /**
   * WATCHERS
   */

  @Watch('$route.query.page', { immediate: true })
  protected async onChangeQueryPage() {
    await this.processCurrentPage()
  }

  @Watch('$route', { deep: true, immediate: true })
  protected async onChangeQueryParams() {
    await this.processUrlQueryParams(this.$route.query)
  }
}
